import React,{useState,useEffect} from 'react'
import axios from 'axios'
import ClientInfo from './ClientInfo'
import AnalyzingReport from './AnalyzingReport'
import Worksheet1 from './Worksheet1'
import Worksheet2 from './Worksheet2'
import Worksheet3 from './Worksheet3'
import Worksheet4 from './Worksheet4'
import Worksheet5 from './Worksheet5'
import Worksheet6 from './Worksheet6'
import Worksheet7 from './Worksheet7'
import { Link, useParams } from "react-router-dom"
import {notify, floatCheck} from '../utils/globalFunction'
import { useHistory } from 'react-router-dom';

const FullAssessment = ({BaseURL,userLogOut}) => {

    const history = useHistory();

    let token = localStorage.getItem('userAccessToken');
    //get param
    const uuseParams = useParams();
    const assessmentId = uuseParams.assessment_id ? uuseParams.assessment_id : "";
    console.log("assessmentId "+assessmentId);
   

    const [clientData,setclientData]= useState([])
    useEffect(() => {
        
        axios.get(`${BaseURL}/api/v1/assessments/retrieve/${assessmentId}`, { headers: { "Authorization": `JWT ${token}` } })
            .then(res => {
                console.log(res.data.data);
              
                setclientData(res.data.data);
                setMainForm(res.data.data);
            }).catch(err =>  {
                if (err.response.status===401) {
                    userLogOut()
                }
            })
    }, [assessmentId]);

    const today = new Date();
    const yyyy = today.getFullYear();
    let mm = today.getMonth() + 1; // Months start at 0!
    let dd = today.getDate();
    if (mm < 10) mm = '0' + mm;
    // const lastmonth = new Date();
    // lastmonth.setMonth(lastmonth.getMonth()-1);
    // const yyyyLM = lastmonth.getFullYear();
    // let mmLM = lastmonth.getMonth()+1;
    // if (mmLM< 10) mmLM = '0' + mmLM;
    const firstmonth = new Date();
    firstmonth.setMonth(1);
    firstmonth.setDate(1);
    const yyyyFM = firstmonth.getFullYear();



    const form =
    {
        id:0,
        client_information:
            { 
                id:0,
                assessment_date:"",
                project_name:"",
                company:"",
                naics:"",
                year_started:"",
                first_name:"",
                last_name:"",
                country:"",
                address:"",
                city:"",
                state:"",
                zip:"",
                email:"",
                main_phone:"",
                other_phone:"",
                business_less_then_12_month:false,
                is_business_owned_by_woman_or_minority:'',
                internal_notes:"",
                currency:""
            },
        progress_bar:25,
        worksheet:
        {
            worksheet_page_1:true,
            worksheet_page_2:true,
            worksheet_page_3:true,
            worksheet_page_4:true,
            worksheet_page_5:true,
            top_line_revenue:"0.00",
            income_from_sale:"0.00",
            interest_income:"0.00",
            other_income:"0.00",
            top_line_notes:null,
            material_subcontractor:"0.00",
            cost_of_good_sales:"0.00",
            real_revenue:"0.00",
            profit:"0.00",
            profit_adjustment:0,
            money_allocated_to_profit_account:"0.00",
            profit_write_here:null,
            money_owner_contributed_to_business:"0.00",
            other_profit:"0.00",
            other_profit_write_here:null,
            proceeds_from_loans:"0.00",
            owner_compensation:"0.00",
            cell_phone_owner:"0.00",
            company_contribution_to_retirement_owner:"0.00",
            health_insurance_owner:"0.00",
            other_personal_expenses:"0.00",
            owners_draw_distribution:"0.00",
            owner_vehicle_expenses_fuel:"0.00",
            owner_vehicle_expenses_insurance:"0.00",
            owner_vehicle_expenses_loan_payment:"0.00",
            owner_vehicle_expenses_repair_maintenance:"0.00",
            wages_from_payroll:"0.00",
            other_owner_compensation:"0.00",
            compensation_write_here:null,
            tax:"0.00",
            owners_draw_for_taxes:"0.00",
            other_taxes:"0.00",
            tax_write_here:null,
            operating_expenses:"0.00",
            operating_expenses_adjustment:0,
            advertising_marketing:"0.00",
            asset_purchase:"0.00",
            bank_service_charge:"0.00",
            bank_insurance:"0.00",
            charitable_contribution:"0.00",
            company_contribution_retirement_staff:"0.00",
            continuing_education:"0.00",
            entertainment:"0.00",
            business_personal_property_tax:"0.00",
            gift:"0.00",
            health_insurance_staff:"0.00",
            interest_expenses:"0.00",
            loan_payment_balance_sheet:"0.00",
            meals:"0.00",
            merchant_service_fees:"0.00",
            office_phone:"0.00",
            office_rent:"0.00",
            office_repair_maintenance:"0.00",
            office_supplies:"0.00",
            office_utilities:"0.00",
            postage_and_delivery:"0.00",
            professional_fees:"0.00",
            telephone:"0.00",
            total_wages_from_payroll:"0.00",
            workers_compensation_insurance:"0.00",
            other_operating_expenses:"0.00",
            expenses_write_here:null,
            analyze_another_year:false,
            other_contract_expenses:"0.00",
            charity:"0.00",
            professional_dev:"0.00",
            equipment:"0.00",
            software_subscription:"0.00",
            staffing:"0.00",
            general_expenses:"0.00",
            investment_fund:"0.00",
            now_what:"",
            edited_quater:"",
            linked_id:null
        },
        analyzing_report:
        {
            analyzing_report_flag:false,
            reports:null,
            taxFile:null,
            incomeStatement:null,
            balanceSheet:null,
            cashFlow:null,
            other_docs_text:null,
            documents:null,
            notes:'',
            run_rate:true,
            month:1,
            starting_month:yyyyFM+'-01-01',
            ending_month:yyyy+'-'+mm+'-01',
            analysing_year:new Date().getFullYear(),
        },
        starting_month:yyyyFM+'-01-01',
        ending_month:yyyy+'-'+mm+'-01',
        current_status:1,
        month_using_in_current_year:1
    }

    const updateWithType = (data, type) => {
       const json =  mainForm;
       Object.keys(json[type]).map((item) => {  

            if (item in data) {
                if(item === 'starting_month'){
                    json['starting_month']=data[item] ? data[item] : '2021-01-01'
                    json[type][item] = data[item] ? data[item] : '2021-01-01'
                }
                else if(item === 'ending_month'){
                    json['ending_month']=data[item] ? data[item] : '2021-01-01'
                    json[type][item] = data[item] ? data[item] : '2021-01-01'
                }
                else if(item === 'month'){
                    json['month_using_in_current_year'] = data[item]
                    json[type][item] = data[item] ? data[item] : 1
                }
               else if(item==='business_less_then_12_month' || item==='is_business_owned_by_woman_or_minority')
                    json[type][item] = data[item]
                else 
                    json[type][item] = data[item]===''? null : data[item]
            } 
       })
       
       setMainForm(json)
    }

    const updateRootItems = (data, item) => {
        const json =  mainForm;
 
 
            
                json[item] = data[item] ? data[item] : 1
             
        
        setMainForm(json)
     }
    const updateWithElement = (value, key) => {
        const json =  mainForm;
        json[key] = value;
        setMainForm(json)
    }

    const updateAnalyze = () =>{
        axios.put(`${BaseURL}/api/v1/assessments/update/${mainForm.id}/`, mainForm, { headers: { "Authorization": `JWT ${token}` } })
        .then(response => {
            // console.log(response.data)
            const res = response.data

            console.log(res)
            // console.log(response); history.push("/analyzing_report")
        })
        .catch(err =>  {
            if (err.response.status===401){
                userLogOut()
            }
        })
    }

    const newAnalyze = () =>{
          
          const new_form =  form;
          new_form.client_information = mainForm.client_information;
          new_form.analyzing_report =mainForm.analyzing_report;
        //   new_form.worksheet =mainForm.worksheet;
        //   delete new_form.analyzing_report.id


        const client_info_user_data = {
            "client_information":{},
            "analyzing_report":{},
            "worksheet": {
                "linked_id":mainForm.id
            },
            "progress_bar":25
        }
        client_info_user_data.client_information = new_form.client_information;
        client_info_user_data.analyzing_report = new_form.analyzing_report;
        delete client_info_user_data.client_information.id
        delete client_info_user_data.analyzing_report.id
        axios.post(`${BaseURL}/api/v1/assessments/create/`, client_info_user_data, { headers: { "Authorization": `JWT ${token}` } })
                .then(async response => {
                    const res = response.data

                    const data = {
                        client_information: res.data.client_information,
                        id:res.data.id
                    }
                   
                    const work={
                        linked_id:res.data.id,
                        worksheet_page_1:true,
                        worksheet_page_2:true,
                        worksheet_page_3:true,
                        worksheet_page_4:true,
                        worksheet_page_5:true,
                        top_line_revenue:"0.00",
                        income_from_sale:"0.00",
                        interest_income:"0.00",
                        other_income:"0.00",
                        top_line_notes:null,
                        material_subcontractor:"0.00",
                        cost_of_good_sales:"0.00",
                        real_revenue:"0.00",
                        profit:"0.00",
                        profit_adjustment:0,
                        money_allocated_to_profit_account:"0.00",
                        profit_write_here:null,
                        money_owner_contributed_to_business:"0.00",
                        other_profit:"0.00",
                        other_profit_write_here:null,
                        proceeds_from_loans:"0.00",
                        owner_compensation:"0.00",
                        cell_phone_owner:"0.00",
                        company_contribution_to_retirement_owner:"0.00",
                        health_insurance_owner:"0.00",
                        other_personal_expenses:"0.00",
                        owners_draw_distribution:"0.00",
                        owner_vehicle_expenses_fuel:"0.00",
                        owner_vehicle_expenses_insurance:"0.00",
                        owner_vehicle_expenses_loan_payment:"0.00",
                        owner_vehicle_expenses_repair_maintenance:"0.00",
                        wages_from_payroll:"0.00",
                        other_owner_compensation:"0.00",
                        compensation_write_here:null,
                        tax:"0.00",
                        owners_draw_for_taxes:"0.00",
                        other_taxes:"0.00",
                        tax_write_here:null,
                        operating_expenses:"0.00",
                        operating_expenses_adjustment:0,
                        advertising_marketing:"0.00",
                        asset_purchase:"0.00",
                        bank_service_charge:"0.00",
                        bank_insurance:"0.00",
                        charitable_contribution:"0.00",
                        company_contribution_retirement_staff:"0.00",
                        continuing_education:"0.00",
                        entertainment:"0.00",
                        business_personal_property_tax:"0.00",
                        gift:"0.00",
                        health_insurance_staff:"0.00",
                        interest_expenses:"0.00",
                        loan_payment_balance_sheet:"0.00",
                        meals:"0.00",
                        merchant_service_fees:"0.00",
                        office_phone:"0.00",
                        office_rent:"0.00",
                        office_repair_maintenance:"0.00",
                        office_supplies:"0.00",
                        office_utilities:"0.00",
                        postage_and_delivery:"0.00",
                        professional_fees:"0.00",
                        telephone:"0.00",
                        total_wages_from_payroll:"0.00",
                        workers_compensation_insurance:"0.00",
                        other_operating_expenses:"0.00",
                        expenses_write_here:null,
                        analyze_another_year:false,
                        other_contract_expenses:"0.00",
                        charity:"0.00",
                        professional_dev:"0.00",
                        equipment:"0.00",
                        software_subscription:"0.00",
                        staffing:"0.00",
                        general_expenses:"0.00",
                        investment_fund:"0.00",
                        now_what:"",
                        edited_quater:"",
                    } 
                    updateWithType(work,'worksheet')
                    await updateAnalyze() 

                    updateWithElement(data.id, 'id')
                    updateWithType(data.client_information,'client_information')
                    


                    updateWithType(new_form.analyzing_report,'analyzing_report')
                    updateAnalyze();
                    console.log("mainform")
                    
                    console.log(mainForm);
                   history.push("/full-assessment/"+res.data.id);
                    setActivePage(3);
                   
                }).catch(err =>  {
                    if(err.response.status===401){
                        userLogOut()
                    }
                })
          // }

    }

    
   
    const [mainForm, setMainForm] =useState(form);
    console.log(mainForm)
    const [activePage, setActivePage] = useState(1)
    const [Q26, setQ26] = useState('')
    const [Q25, setQ25] = useState('')
    const [Q20, setQ20] = useState('')

    const [Q27, setQ27] = useState('')
    const [Q34, setQ34] = useState('')
    const [Q48, setQ48] = useState('')
    const [Q52, setQ52] = useState('')
    const [WorksheetYear, setWorksheetYear] = useState('')

        
    useEffect(() => {
                
        const D20 = floatCheck(mainForm?.worksheet?.top_line_revenue)
        const D21 = floatCheck(mainForm?.worksheet?.income_from_sale)
        const D22 = floatCheck(mainForm?.worksheet?.interest_income)
        const D23 = floatCheck(mainForm?.worksheet?.other_income)
        const D25 = floatCheck(mainForm?.worksheet?.material_subcontractor)
        setQ25(D25)
        setQ20((parseFloat((typeof D21==='undefined' || D21==='' || Number.isNaN(D21))? 0 : D21) + parseFloat((typeof D22==='undefined' || D22==='' || Number.isNaN(D22))? 0 : D22) + parseFloat((typeof D23==='undefined' || D23==='' || Number.isNaN(D23))? 0 : D23)).toFixed()) 
        setQ26((parseFloat((typeof D20==='undefined' || D20==='' || Number.isNaN(D20))? 0 : D20)))


        
        const D28 = floatCheck(mainForm?.worksheet?.money_allocated_to_profit_account)
        const D30 = floatCheck(mainForm?.worksheet?.other_profit)
        const D31 = floatCheck(mainForm?.worksheet?.money_owner_contributed_to_business)
        const D33 = floatCheck(mainForm?.worksheet?.proceeds_from_loans)
        setQ27((parseFloat((typeof D28==='undefined' || D28==='' || Number.isNaN(D28))? 0 : D28) - parseFloat((typeof D30==='undefined' || D30===''  || Number.isNaN(D30))? 0 : D30) + parseFloat((typeof D31==='undefined' || D31===''  || Number.isNaN(D31))? 0 : D31) - parseFloat((typeof D33==='undefined' || D33===''  || Number.isNaN(D33))? 0 : D33)).toFixed())
        

        const D35 = floatCheck(mainForm?.worksheet?.cell_phone_owner)
        const D36 = floatCheck(mainForm?.worksheet?.company_contribution_to_retirement_owner)
        const D37 = floatCheck(mainForm?.worksheet?.health_insurance_owner)
        const D39 = floatCheck(mainForm?.worksheet?.other_personal_expenses)
        const D40 = floatCheck(mainForm?.worksheet?.owners_draw_distribution)
        const D41 = floatCheck(mainForm?.worksheet?.owner_vehicle_expenses_fuel)
        const D42 = floatCheck(mainForm?.worksheet?.owner_vehicle_expenses_insurance)
        const D43 = floatCheck(mainForm?.worksheet?.owner_vehicle_expenses_loan_payment)
        const D44 = floatCheck(mainForm?.worksheet?.owner_vehicle_expenses_repair_maintenance)
        const D45 = floatCheck(mainForm?.worksheet?.wages_from_payroll)
        const D46 = floatCheck(mainForm?.worksheet?.other_owner_compensation)

        setQ34((parseFloat((typeof D35==='undefined' || D35===''  || Number.isNaN(D35))? 0 : D35) + parseFloat((typeof D36==='undefined' || D36===''  || Number.isNaN(D36))? 0 : D36) + parseFloat((typeof D37==='undefined' || D37===''  || Number.isNaN(D37))? 0 : D37) + parseFloat((typeof D39==='undefined' || D39===''  || Number.isNaN(D39))? 0 : D39) + parseFloat((typeof D40==='undefined' || D40===''  || Number.isNaN(D40))? 0 : D40) + parseFloat((typeof D41==='undefined' || D41==='' || Number.isNaN(D41))? 0 : D41) + parseFloat((typeof D42==='undefined' || D42===''  || Number.isNaN(D42))? 0 : D42) + parseFloat((typeof D43==='undefined' || D43===''  || Number.isNaN(D43))? 0 : D43) + parseFloat((typeof D44==='undefined' || D44===''  || Number.isNaN(D44))? 0 : D44) + parseFloat((typeof D45==='undefined' || D45===''  || Number.isNaN(D45))? 0 : D45) + parseFloat((typeof D46==='undefined' || D46===''  || Number.isNaN(D46))? 0 : D46)).toFixed())

        const D49 = floatCheck(mainForm?.worksheet?.owners_draw_for_taxes)
        const D50 = floatCheck(mainForm?.worksheet?.other_taxes)
        setQ48((parseFloat((typeof D49==='undefined' || D49==='' || Number.isNaN(D49))? 0 : D49) + parseFloat((typeof D50==='undefined' || D50==='' || Number.isNaN(D50))? 0 : D50)).toFixed())
 
        const D53 = floatCheck(mainForm?.worksheet?.advertising_marketing)
        const D54 = floatCheck(mainForm?.worksheet?.asset_purchase)
        const D55 = floatCheck(mainForm?.worksheet?.bank_service_charge)
        const D56 = floatCheck(mainForm?.worksheet?.bank_insurance)
        const D57 = floatCheck(mainForm?.worksheet?.charitable_contribution)
        const D58 = floatCheck(mainForm?.worksheet?.company_contribution_retirement_staff)
        const D59 = floatCheck(mainForm?.worksheet?.continuing_education)
        const D60 = floatCheck(mainForm?.worksheet?.entertainment)
        const D61 = floatCheck(mainForm?.worksheet?.business_personal_property_tax)
        const D62 = floatCheck(mainForm?.worksheet?.gift)
        const D63 = floatCheck(mainForm?.worksheet?.health_insurance_staff)
        const D64 = floatCheck(mainForm?.worksheet?.interest_expenses)
        const D65 = floatCheck(mainForm?.worksheet?.loan_payment_balance_sheet)
        const D66 = floatCheck(mainForm?.worksheet?.meals)
        const D67 = floatCheck(mainForm?.worksheet?.merchant_service_fees)
        const D68 = floatCheck(mainForm?.worksheet?.office_phone)
        const D69 = floatCheck(mainForm?.worksheet?.office_rent)
        const D70 = floatCheck(mainForm?.worksheet?.office_repair_maintenance)
        const D71 = floatCheck(mainForm?.worksheet?.office_supplies)
        const D72 = floatCheck(mainForm?.worksheet?.office_utilities)
        const D73 = floatCheck(mainForm?.worksheet?.other_contract_expenses)
        const D74 = floatCheck(mainForm?.worksheet?.postage_and_delivery)
        const D75 = floatCheck(mainForm?.worksheet?.professional_fees)
        const D76 = floatCheck(mainForm?.worksheet?.telephone)
        const D77 = floatCheck(mainForm?.worksheet?.total_wages_from_payroll)
        const D78 = floatCheck(mainForm?.worksheet?.workers_compensation_insurance)
        const D79 = floatCheck(mainForm?.worksheet?.other_operating_expenses)


        setQ52((parseFloat((typeof D53==='undefined' || D53==='' || Number.isNaN(D53))? 0 : D53) + parseFloat((typeof D54==='undefined' || D54==='' || Number.isNaN(D54))? 0 : D54) + parseFloat((typeof D55==='undefined' || D55==='' || Number.isNaN(D55))? 0 : D55) + parseFloat((typeof D56==='undefined' || D56==='' || Number.isNaN(D56))? 0 : D56) + parseFloat((typeof D57==='undefined' || D57==='' || Number.isNaN(D57))? 0 : D57) + parseFloat((typeof D58==='undefined' || D58==='' || Number.isNaN(D58))? 0 : D58) + parseFloat((typeof D59==='undefined' || D59==='' || Number.isNaN(D59))? 0 : D59) + parseFloat((typeof D60==='undefined' || D60==='' || Number.isNaN(D60))? 0 : D60) + parseFloat((typeof D61==='undefined' || D61==='' || Number.isNaN(D61))? 0 : D61) + parseFloat((typeof D62==='undefined' || D62==='' || Number.isNaN(D62))? 0 : D62) + parseFloat((typeof D63==='undefined' || D63==='' || Number.isNaN(D63))? 0 : D63) + parseFloat((typeof D64==='undefined' || D64==='' || Number.isNaN(D64))? 0 : D64) + parseFloat((typeof D65==='undefined' || D65==='' || Number.isNaN(D65))? 0 : D65) + parseFloat((typeof D66==='undefined' || D66==='' || Number.isNaN(D66))? 0 : D66) + parseFloat((typeof D67==='undefined' || D67==='' || Number.isNaN(D67))? 0 : D67) + parseFloat((typeof D68==='undefined' || D68==='' || Number.isNaN(D68))? 0 : D68) + parseFloat((typeof D69==='undefined' || D69==='' || Number.isNaN(D69))? 0 : D69) + parseFloat((typeof D70==='undefined' || D70==='' || Number.isNaN(D70))? 0 : D70) + parseFloat((typeof D71==='undefined' || D71==='' || Number.isNaN(D71))? 0 : D71) + parseFloat((typeof D72==='undefined' || D72==='' || Number.isNaN(D72))? 0 : D72) + parseFloat((typeof D73==='undefined' || D73==='' || Number.isNaN(D73))? 0 : D73) + parseFloat((typeof D74==='undefined' || D74==='' || Number.isNaN(D74))? 0 : D74) + parseFloat((typeof D75==='undefined' || D75==='' || Number.isNaN(D75))? 0 : D75) + parseFloat((typeof D76==='undefined' || D76==='' || Number.isNaN(D76))? 0 : D76) + parseFloat((typeof D77==='undefined' || D77==='' || Number.isNaN(D77))? 0 : D77) + parseFloat((typeof D78==='undefined' || D78==='' || Number.isNaN(D78))? 0 : D78) + parseFloat((typeof D79==='undefined' || D79==='' || Number.isNaN(D79))? 0 : D79)).toFixed())
        

    }, [mainForm]);
    
    return (
        <>
            {activePage===1?
                <ClientInfo
                    mainData={mainForm}
                    BaseURL={BaseURL}
                    userLogOut={userLogOut}
                    submitCall={(data)=>{
                        setActivePage(2)
                        updateWithElement(data.id, 'id')
                        updateWithType(data.client_information,'client_information')  
                    }}
                    gotoWorksheet={()=>setActivePage(3)}
                    gotoRunRate={()=>setActivePage(8)}
                    />
            : null}
            {activePage===2?
                <AnalyzingReport
                    mainData={mainForm}
                    BaseURL={BaseURL}
                    submitCall={(data)=>{
                        setActivePage(3)
                        updateWithType(data,'analyzing_report')  
                        updateAnalyze()
                    }}
                    saveCall={(data)=>{
                        updateWithType(data,'analyzing_report')  
                        updateAnalyze()
                    }} 
                    backCall={()=>setActivePage(1)}
                    />
            : null}
            {activePage===3?
                <Worksheet1
                    mainData={mainForm}
                    BaseURL={BaseURL}
                    Q26={Q26}
                    setQ26={setQ26}
                    WorksheetYear={WorksheetYear}
                    submitCall={(value,value2,value3,data)=>{
                        setActivePage(4);
                        setQ26(value);
                        setQ25(value2);
                        setQ20(value3);
                        updateWithType(data,'worksheet');  
                        updateAnalyze();
                    }}
                    saveCall={(value,value2,value3,data)=>{
                        setQ26(value);
                        setQ25(value2);
                        setQ20(value3);
                        updateWithType(data,'worksheet');  
                        updateAnalyze();
                    }}
                    backCall={()=>setActivePage(2)}
                    />
            : null}
            {activePage===4?
                <Worksheet2
                    mainData={mainForm}
                    BaseURL={BaseURL}
                    Q27={Q27}
                    setQ27={setQ27}
                    WorksheetYear={WorksheetYear}
                    submitCall={(value,data)=>{
                        setActivePage(5);
                        setQ27(value);
                        updateWithType(data,'worksheet')
                        updateAnalyze()     
                    }
                    }
                    saveCall={(value,data)=>{
                        setQ27(value);
                        updateWithType(data,'worksheet')
                        updateAnalyze()     
                    }
                    }
                    backCall={()=>setActivePage(3)}
                    />
            : null}
            {activePage===5?
                <Worksheet3
                    mainData={mainForm}
                    BaseURL={BaseURL}
                    Q34={Q34}
                    setQ34={setQ34}
                    WorksheetYear={WorksheetYear}
                    submitCall={(value,data)=>{
                        setActivePage(6);
                        setQ34(value);   
                        updateWithType(data,'worksheet')   
                        updateAnalyze()    
                    }}
                    saveCall={(value,data)=>{
                        setQ34(value);   
                        updateWithType(data,'worksheet')   
                        updateAnalyze()    
                    }}
                    backCall={()=>setActivePage(4)}
                    />
            : null}
            {activePage===6?
                <Worksheet4
                    mainData={mainForm}
                    BaseURL={BaseURL}
                    Q48={Q48}
                    setQ48={setQ48}
                    WorksheetYear={WorksheetYear}
                    submitCall={(value,data)=>{
                        setActivePage(7);
                        setQ48(value);
                        updateWithType(data,'worksheet') 
                        updateAnalyze()    
                        }
                    }
                    saveCall={(value,data)=>{
                        setQ48(value);
                        updateWithType(data,'worksheet') 
                        updateAnalyze()    
                        }
                    }
                    backCall={()=>setActivePage(5)}
                    />
            : null}
            {activePage===7?
                <Worksheet5
                    mainData={mainForm}
                    BaseURL={BaseURL}
                    Q52={Q52}
                    setQ52={setQ52}
                    WorksheetYear={WorksheetYear}
                    submitCall={(value,data)=>{
                        setActivePage(8);
                        setQ52(value);
                        updateWithType(data,'worksheet') 
                        updateAnalyze()    
                        }
                    }
                    saveCall={(value,data)=>{
                        setQ52(value);
                        updateWithType(data,'worksheet') 
                        updateAnalyze()    
                        }
                    }
                    backCall={()=>setActivePage(6)}
                    setWorksheetYear={value=>setWorksheetYear(value)}
                    />
            : null}
            {/* {activePage===8?
                <Worksheet7
                    mainData={mainForm}
                    BaseURL={BaseURL}
                    WorksheetYear={WorksheetYear}
                    submitCall={(data)=>{
                        setActivePage(9);
                        updateWithType(data,'worksheet') 
                        updateAnalyze()    
                        }
                    }
                    backCall={()=>setActivePage(7)}
                    setWorksheetYear={value=>setWorksheetYear(value)}
                    />
            : null} */}
            {activePage===8?
                <Worksheet6
                    mainData={mainForm}
                    real={Q26}
                    topLine={Q20}
                    mat={Q25}
                    profit={Q27}
                    owner={Q34}
                    tax={Q48}
                    opEx={Q52}
                    adjustmentCall={(data)=>{
                        updateWithType(data,'worksheet') 
                        updateAnalyze()  
                    }}
                    BaseURL={BaseURL}
                    backCall={()=>setActivePage(7)}
                    analyzeCall={(data)=>{
                        //setActivePage(3)
                        console.log(data,'yooooo');
                        updateWithType(data,'analyzing_report')
                        newAnalyze() 
                    }}
                    updateCurrentStatus={(data)=>{
                        updateRootItems(data,'current_status')  
                        updateAnalyze()    
                        }
                    }
                    />
            : null}
        </>
    )

}
export default FullAssessment